import { Color } from 'presentation/theme/colorScheme';

const usePeCompanyColor = (color: string | null, gradientColor: string | null): string => {
  let background: string;
  if (color) {
    if (gradientColor) {
      background = `linear-gradient(180deg, ${color} 0%, ${gradientColor} 100%)`;
    } else {
      background = color;
    }
  } else {
    background = Color.Primary500;
  }

  return background;
};

export default usePeCompanyColor;
